import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Warning } from "@phosphor-icons/react";
import { SYMPTOMS } from "../data/seo";

export const SymptomsSection = () => (
  <section data-testid="symptoms-section" className="container-ccc py-20 border-b border-stone-200/50">
    <div className="max-w-3xl mb-10">
      <div className="eyebrow">Symptoms we assess</div>
      <h2 className="font-serif text-3xl mt-3">Worried about a symptom?</h2>
      <p className="mt-3 text-ink-muted text-lg leading-relaxed">
        Our consultant physicians in Cambridge see adults with symptoms that may be linked to the heart, blood pressure or metabolic health, and arrange the right tests, such as an ECG or an echo heart scan.
      </p>
    </div>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {SYMPTOMS.map((s) => (
        <Link key={s.name} to={s.to} data-testid={`symptom-${s.name.split(" ")[0].toLowerCase()}`}
          className="group p-6 bg-white border border-stone-200/60 rounded-md hover:border-bronze-light transition-colors">
          <h3 className="font-serif text-xl">{s.name}</h3>
          <p className="mt-2 text-sm text-ink-muted">{s.text}</p>
          <span className="mt-4 inline-flex items-center gap-1 text-sm text-bronze-dark">How we help <ArrowRight size={14} className="transition-transform group-hover:translate-x-0.5" /></span>
        </Link>
      ))}
    </div>
    <p data-testid="symptoms-emergency-note" className="mt-8 text-sm text-ink flex items-start gap-2 max-w-3xl">
      <Warning size={18} weight="duotone" className="text-red-700 shrink-0 mt-0.5" />
      If you have chest pain now, severe breathlessness, or you feel very unwell, call 999. For urgent advice, call NHS 111. Our clinic is for planned appointments only.
    </p>
  </section>
);
